import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

/** Dados passados ao abrir o diálogo via `MatDialog.open(ConfirmacaoDialogComponent, { data })`. */
export interface ConfirmacaoDialogData {
  titulo: string;
  mensagem: string;
  textoConfirmar: string;
  corConfirmar?: 'primary' | 'warn' | 'accent';
}

/**
 * Diálogo Material de confirmação (título, mensagem, botão principal customizável).
 *
 * **Uso:** `this.dialog.open(ConfirmacaoDialogComponent, { width: '440px', data: { ... } })`;
 * o retorno é `afterClosed()` com `true` se o usuário confirmou. Ideal para exclusões
 * ou ações destrutivas sem lógica de negócio no próprio componente.
 */
@Component({
  selector: 'app-confirmacao-dialog',
  templateUrl: './confirmacao-dialog.component.html',
  styleUrls: ['./confirmacao-dialog.component.scss'],
})
export class ConfirmacaoDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmacaoDialogData
  ) {}
}
